export const supportedAddresses = ['eth', 'btc', 'bnb', 'doge', 'ltc', 'dot', 'sol'] as const
